<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: true,
            },
        },
    };
</script>

<template>
    <div v-show="show" class="loading">
        <img class="loading__image" src="/images/falagrett-c-white.svg" alt="Falagrett - Loading" />
        <span class="loading__text">Laddar ...</span>
    </div>
</template>
